export type CellPos = {
  x: number;
  y: number;
};
export const cellPosKey = ({ x, y }: CellPos) => `${y}:${x}`;
